<div class="dialog-header">
    <h2 mat-dialog-title class="lmc-dialog-title dialog-title-icon">
        <mat-icon color="primary">restore</mat-icon>
        Restore co-applicant
    </h2>
    <button mat-icon-button mat-dialog-close type="button"
            class="close-button" aria-label="Close without restoring" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <p *ngIf="data.removals.length; else noRemovals">
        Choose the co-applicant to restore to this application.
        To add a new co-applicant instead, close this and enter their details in the form.
    </p>
    <ng-template #noRemovals>
        <p>There are no removed co-applicants to restore.</p>
    </ng-template>

    <ng-container *ngIf="data.removals.length">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Co-applicant</mat-label>
            <mat-select [formControl]="selected" panelClass="restore-co-applicant-panel">
                <mat-select-trigger>{{ displayName(selected.value) }}</mat-select-trigger>
                <mat-option *ngFor="let removal of data.removals; trackBy: trackById" [value]="removal">
                    <span class="option-name">{{ displayName(removal) }}</span>
                    <span class="option-meta">Removed {{ formatDateTime(removal.removedDate) }}</span>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="selected.hasError('required')">Choose a co-applicant</mat-error>
        </mat-form-field>

        <div class="removal-details" *ngIf="selected.value as removal">
            <div class="removal-meta">
                Removed by {{ removal.removedBy }} on {{ formatDateTime(removal.removedDate) }}
            </div>
            <div class="removal-meta" *ngIf="removal.removalReason">Reason: {{ removal.removalReason }}</div>
        </div>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Reason for restoring</mat-label>
            <textarea matInput [formControl]="reason" rows="2" [maxlength]="reasonMaxLength"></textarea>
            <mat-hint align="end">{{ reason.value.length }} / {{ reasonMaxLength }}</mat-hint>
            <mat-error *ngIf="reason.hasError('required')">A reason is required</mat-error>
        </mat-form-field>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button type="button" mat-dialog-close>Cancel</button>
    <button *ngIf="data.removals.length" mat-raised-button color="primary" type="button"
            [disabled]="selected.invalid || reason.invalid" (click)="onRestore()">
        <mat-icon>restore</mat-icon>
        Restore
    </button>
</mat-dialog-actions>
